export default __webpack_public_path__ + "static/media/img26.7779a331.jpg";